<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 448 512"
    stroke-width="50"
    stroke="white"
    class="w-8 h-8 text-red-700 bg-orange-500 p-2 rounded-full"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"
    />
  </svg>
</template>

<script>
export default {
  name: "PlusIcon",
}
</script>

<style></style>
